import { Offering } from '@arrived/models';

import { canOfferingStatusReserveShares } from './canOfferingStatusReserveShares';

export const canReserveShares = (offering: Offering): boolean => {
  return canOfferingStatusReserveShares(offering.status);
};
